(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!customElements.get('premiere-product-progress')) {
    customElements.define('premiere-product-progress', class extends HTMLElement {
      connectedCallback() {
        const gallery = this.closest('media-gallery');
        if (!gallery) return;
        this.#init(gallery);
      }

      #init(gallery) {
        const slidesEl = gallery.querySelector('slideshow-slides');
        if (!slidesEl) return;

        const slides = Array.from(slidesEl.querySelectorAll('.product-media-container'));
        if (slides.length <= 1) return;

        const count = slides.length;

        this.innerHTML = Array.from({ length: count }, () =>
          '<span class="premiere-product-progress__segment"></span>'
        ).join('');
        this.classList.add('premiere-product-progress--loaded');

        const segments = Array.from(this.querySelectorAll('.premiere-product-progress__segment'));

        const slideshowContainer = gallery.querySelector('slideshow-container');
        if (slideshowContainer && !slideshowContainer.querySelector('.premiere-gallery-arrow')) {
          ['prev', 'next'].forEach((dir) => {
            const btn = document.createElement('button');
            btn.className = `premiere-gallery-arrow premiere-gallery-arrow--${dir} button-unstyled`;
            btn.setAttribute('aria-label', dir === 'prev' ? 'Image précédente' : 'Image suivante');
            btn.innerHTML = dir === 'prev'
              ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
              : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
            btn.addEventListener('click', () => {
              slidesEl.scrollBy({ left: dir === 'prev' ? -slidesEl.clientWidth : slidesEl.clientWidth, behavior: 'smooth' });
            });
            slideshowContainer.appendChild(btn);
          });
        }

        segments.forEach((seg, i) => {
          seg.style.cursor = 'pointer';
          seg.addEventListener('click', () => {
            const max = slidesEl.scrollWidth - slidesEl.clientWidth;
            slidesEl.scrollTo({ left: (i / count) * max, behavior: 'smooth' });
          });
        });


        const prevBtn = slideshowContainer && slideshowContainer.querySelector('.premiere-gallery-arrow--prev');
        const nextBtn = slideshowContainer && slideshowContainer.querySelector('.premiere-gallery-arrow--next');

        const update = () => {
          const atEnd = slidesEl.scrollLeft >= slidesEl.scrollWidth - slidesEl.clientWidth - 10;
          const currentIndex = atEnd ? count - 1 : Math.min(count - 1, Math.round(slidesEl.scrollLeft / slidesEl.clientWidth));
          segments.forEach((seg, i) => {
            seg.setAttribute('aria-selected', i <= currentIndex ? 'true' : 'false');
          });
          if (prevBtn) prevBtn.style.display = currentIndex === 0 ? 'none' : '';
          if (nextBtn) nextBtn.style.display = currentIndex === count - 1 ? 'none' : '';
        };

        let scrollTimer;
        slidesEl.addEventListener('scroll', () => {
          update();
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(update, 100);
        }, { passive: true });
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premiere-reco-progress')) {
    customElements.define('premiere-reco-progress', class extends HTMLElement {
      connectedCallback() {
        const recoEl = this.closest('product-recommendations');
        if (!recoEl) return;

        if (recoEl.dataset.recommendationsPerformed === 'true') {
          this.#init(recoEl);
          return;
        }

        const observer = new MutationObserver(() => {
          if (recoEl.dataset.recommendationsPerformed === 'true') {
            observer.disconnect();
            this.#init(recoEl);
          }
        });
        observer.observe(recoEl, { attributes: true, attributeFilter: ['data-recommendations-performed'] });
      }

      #init(recoEl) {
        const slideshow = recoEl.querySelector('slideshow-component');
        if (!slideshow) return;

        const slidesEl = slideshow.querySelector('slideshow-slides');
        const slides = Array.from(slideshow.querySelectorAll('.resource-list__slide'));
        if (slides.length === 0 || !slidesEl) return;

        const count = slides.length;
        this.innerHTML = Array.from({ length: count }, () =>
          `<span class="premiere-reco-progress__segment"></span>`
        ).join('');
        this.classList.add('premiere-reco-progress--loaded');

        const segments = Array.from(this.querySelectorAll('.premiere-reco-progress__segment'));

        console.log('[premiere-reco-progress] init', { count, scrollWidth: slidesEl.scrollWidth, clientWidth: slidesEl.clientWidth, widthRatio: (slidesEl.clientWidth / slidesEl.scrollWidth * 100).toFixed(1) + '%' });


        const update = () => {
          const maxScrollLeft = slidesEl.scrollWidth - slidesEl.clientWidth;
          const currentIndex = maxScrollLeft > 0
            ? Math.min(count - 1, Math.round((slidesEl.scrollLeft / maxScrollLeft) * (count - 1)))
            : 0;
          segments.forEach((seg, i) => {
            seg.setAttribute('aria-selected', i <= currentIndex ? 'true' : 'false');
          });
        };

        segments.forEach((seg, i) => {
          seg.style.cursor = 'pointer';
          seg.addEventListener('click', () => {
            const max = slidesEl.scrollWidth - slidesEl.clientWidth;
            slidesEl.scrollTo({ left: (i / (count - 1)) * max, behavior: 'smooth' });
          });
        });

        let scrollTimer;
        slidesEl.addEventListener('scroll', () => {
          update();
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(update, 100);
        }, { passive: true });
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
